// extracted by mini-css-extract-plugin
module.exports = {"btn":"Downloader_btn__33bfG"};